import { ControlPanelService } from 'src/states/control-panel.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  token: string = null;

  constructor(private controlPanelService: ControlPanelService) {
      this.controlPanelService.token$.subscribe(t => (this.token = t));
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const token = this.token;
      if (token != null) {
        request = request.clone({
          withCredentials: true,
          setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
      }
      return next.handle(request);
    }
}
